"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFaciliti = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("./config");
const scriptPath = 'https://cdn.facil-iti.app/tags/faciliti-tag.min.js';
const testId = 'facil-iti-script';
const script = (token) => `
  (function () {
         var fs = document.createElement("script");
         fs.setAttribute("src", "${scriptPath}");
         fs.dataset.applicationIdentifier = "${token}";
         document.head.appendChild(fs);
     }());
`;
const initFaciliti = (siteId) => {
    var _a;
    const token = (_a = config_1.config === null || config_1.config === void 0 ? void 0 : config_1.config['ids']) === null || _a === void 0 ? void 0 : _a[String(siteId)];
    if (token && !(window === null || window === void 0 ? void 0 : window.document.querySelector(`script[src*="${scriptPath}"]`))) {
        const fs = window === null || window === void 0 ? void 0 : window.document.createElement('script');
        if (fs) {
            fs.setAttribute('src', scriptPath);
            fs.dataset.applicationIdentifier = token;
            window === null || window === void 0 ? void 0 : window.document.head.appendChild(fs);
        }
    }
};
exports.initFaciliti = initFaciliti;
const FacilitiScript = ({ siteId, className }) => {
    var _a;
    const token = (_a = config_1.config === null || config_1.config === void 0 ? void 0 : config_1.config['ids']) === null || _a === void 0 ? void 0 : _a[String(siteId)];
    if (!token)
        return null;
    return (0, jsx_runtime_1.jsx)("script", { "data-testid": testId, className: className, type: "text/plain", dangerouslySetInnerHTML: { __html: script(token) } });
};
exports.default = FacilitiScript;
